import BaseModelInstance from './base.model'
import { AvClientGroup as ModelDefinition } from './model-definitions'

class AvClientGroup extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default AvClientGroup
